import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpHeaders,
    HttpInterceptor,
    HttpParams,
    HttpRequest,
    HttpResponse
} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {SESSION_STORAGE_KEYS} from './session-storage-keys';
import {catchError, map} from 'rxjs/operators';
import {LockScreenService} from "./lock-screen.service";
import {finalize} from "rxjs/internal/operators";
import {NotificationService} from "./notification/notification.service";
import {Router} from '@angular/router';
import {connectApi} from "./connect-api";


@Injectable()
export class ConnectHttpInterceptor implements HttpInterceptor {
    constructor(private lockScreenService: LockScreenService,
                private  notificationService: NotificationService,
                private router: Router) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let tokens: any = JSON.parse(sessionStorage.getItem(SESSION_STORAGE_KEYS.tokens));
        let token = '';
        if (tokens && tokens.length) {
            tokens = this.removeExpiredTokens(tokens);
            sessionStorage.setItem(SESSION_STORAGE_KEYS.tokens, JSON.stringify(tokens));
            if(tokens.length){
                token = tokens[tokens.length - 1];
            }
        }

        let authReq;
        if(request.url.includes('/upload') || request.url.includes('/parseAndUpload')){
            authReq = request.clone({
                headers: new HttpHeaders({
                        'Accept': 'application/json',
                        'Authorization': token,
                    }
                )
            });
        } else {
            authReq = request.clone({
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': token,
                })
            });
        }

        if (!this.ignoreLockScreen(request)) {
            this.lockScreenService.lockScreen = true;
        }
        return next.handle(authReq).pipe(
            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    event.headers.keys();
                    this.checkForNewToken(event);
                    this.checkForSessionId(event);
                    return event;
                }
            }),
            catchError((error: HttpErrorResponse) => {
                if (error.status === 401 && error.error === 'ANOTHER_SESSION') {
                    this.lockScreenService.lockScreen = false;
                    this.router.navigateByUrl('login?sto=1');
                } else if (error.status === 401 && error.error === 'SESSION_EXPIRED') {
                    this.lockScreenService.lockScreen = false;
                    this.router.navigateByUrl('login?sto=2');
                } else if (error.status === 400 && error?.error?.Error?.errorCode === 'app.accountLockedOut' &&  error?.url?.includes(connectApi.login)) {
                    //do not display the server error message with notificationService in this scenario
                    return throwError(error);
                } else {
                    this.notificationService.showServerError(error);
                    return throwError(error);
                }
             }), finalize(() => {
                if (!this.ignoreLockScreen(request)) {
                    this.lockScreenService.lockScreen = false;
                }
            })
        )
    }

    private checkForNewToken(res: HttpResponse<any>): void {

        let token: string = res.headers.get('authorization');
        if (token) {
            let tokens: any = sessionStorage.getItem(SESSION_STORAGE_KEYS.tokens);
            if (tokens && tokens.length) {
                tokens = JSON.parse(sessionStorage.getItem(SESSION_STORAGE_KEYS.tokens));
                if (token != tokens[tokens.length - 1]) { //Prevent adding a repeated last token
                    tokens.push(token);
                }

            } else {
                tokens = [token];
            }
            sessionStorage.setItem(SESSION_STORAGE_KEYS.tokens, JSON.stringify(tokens));
        }
    }

    private checkForSessionId(res: HttpResponse<any>): void {
        let sessionId: string = res.headers.get(SESSION_STORAGE_KEYS.sessionId);
        if (sessionId) {
            sessionStorage.setItem(SESSION_STORAGE_KEYS.sessionId, sessionId);
        }
    }

    private ignoreLockScreen(request: HttpRequest<any>): boolean {
        return (request.params instanceof CustomHttpParams && request.params['ignoreLockScreen'])
    }

    private removeExpiredTokens(tokens : string[]) : string[] {
        return tokens.filter(token => this.isActiveToken(token));
    }

    private isActiveToken(token : string): boolean {
        return this.parseJwt(token).exp > (Date.now()/1000);
    }

    private parseJwt (token) {
        let base64Url = token.split('.')[1];
        let base64 = base64Url.replace('-', '+').replace('_', '/');
        return JSON.parse(window.atob(base64));
    }

}

export class CustomHttpParams extends HttpParams {
    constructor(public ignoreLockScreen: boolean) {
        super();
    }
}
